import { QueryResult } from '@apollo/client';
import { AllApplicationStatusesQuery } from './columnFilter/useAllApplicationStatuses';
import { AllCategoriesQuery } from './columnFilter/useAllCategories';
import { AllClassificationQuery } from './columnFilter/useAllClassification';
import { AllEntryStatusEnumQuery } from './columnFilter/useAllEntryStatusEnum';
import { AllEventsQuery } from './columnFilter/useAllEvents';
import { AllGenderEnumQuery } from './columnFilter/useAllGenderEnum';
import { AllGroupsQuery } from './columnFilter/useAllGroups';
import { AllRoomLocationQuery } from './columnFilter/useAllRoomLocation';
import { AllRoomSpaceQuery } from './columnFilter/useAllRoomSpace';
import { AllRoomTypesQuery } from './columnFilter/useAllRoomTypes';
import { AllSituationResponseEnumQuery } from './columnFilter/useAllSituationResponseEnum';
import { AllTermSessionQuery } from './columnFilter/useAllTermSession';
import { EntryStatusEnum } from './useMainDirectoryQuery';

export type ColumnFilterGenericFieldsEnum = 'DESCRIPTION';

export interface IColumnFilterVariables {
    limit?: number;
    skip?: number;
    filter?: IColumnFilterSearchFilter[];
    sort?: IColumnFilterSorting[];
}

export interface IColumnFilterSearchFilter {
    search?: { like?: string };
}

export interface IColumnFilterSorting {
    field: ColumnFilterGenericFieldsEnum;
    order: global.SortOrderEnum;
}

export interface IColumnFilterItem {
    id: string | EntryStatusEnum;
    description: string;
}

export interface IColumnFilterItemList {
    [name: string]: {
        nodes: IColumnFilterItem[];
    };
}

export interface IColumnFilterQuery {
    queryName: string;
    useColumnFilter: (variables: IColumnFilterVariables) => QueryResult<IColumnFilterItemList, IColumnFilterVariables>;
}
export const getColumnFilterQuery = (field: string): IColumnFilterQuery | null => {
    switch (field) {
        case 'roomSpace_Description':
            return AllRoomSpaceQuery;
        case 'applicationStatus_Description':
            return AllApplicationStatusesQuery;
        case 'roomLocation_Description':
            return AllRoomLocationQuery;
        case 'roomType_Description':
            return AllRoomTypesQuery;
        case 'group_Description':
            return AllGroupsQuery;
        case 'event_Description':
            return AllEventsQuery;
        case 'level1':
        case 'level2':
        case 'level3':
        case 'level4':
        case 'category_Description':
            return AllCategoriesQuery;
        case 'termSession_Description':
            return AllTermSessionQuery;
        case 'classification_Description':
            return AllClassificationQuery;
        case 'entryStatus.value':
            return AllEntryStatusEnumQuery;
        case 'genderEnum_Description':
            return AllGenderEnumQuery;
        case 'situationResponse_Description':
            return AllSituationResponseEnumQuery;
        default:
            return null;
    }
};
